import { Routes } from '@common-packages/routes-definitions';

import { LinkCellRendererFactory } from '../../../shared/columnDefinitions/cellRenderers';
import { defaultColumnDefinition } from '../../../shared/columnDefinitions';
import { REPORT_TYPES } from '../../shared/constants';

const ReportLinkRenderer = LinkCellRendererFactory({
  getText: ({ value }) => value,
  getPathName: (value, { reportId }) =>
    Routes.viewCustomReport.compiledRoute({ reportId, reportType: REPORT_TYPES.CHART }),
});

const columnDefinitions = [
  {
    ...defaultColumnDefinition,
    headerName: 'Visualization ID',
    field: 'reportId',
    width: 60,
    minWidth: 60,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Visualization Name',
    field: 'name',
    width: 400,
    minWidth: 400,
    cellRenderer: ReportLinkRenderer,
  },
];

export default columnDefinitions;
